import React, { Component } from "react";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import { ClipLoader } from "react-spinners";
import DatePicker from "react-datepicker";
import { CustomerTeamSelect } from "~/utils";
import AsyncSelect from "react-select/async";
import { Link } from "react-router-dom";
import * as moment from "moment";
import swal from "sweetalert";
import { service as oetService } from "../redux";

const validationSchema = Yup.object().shape({
    start_date: Yup.date().nullable().required("Start date is required"),
    end_date: Yup.date().nullable().required("End date is required")
});

class OETDashboardReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadig: false
        };
    }
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-8">
                        <Formik
                            validationSchema={validationSchema}
                            initialValues={{
                                start_date: null,
                                end_date: null,
                                customer_teams_id__in: null,
                                oet_id: "",
                                oet_name: "",
                                cpo_numbers: "",
                                circle: "",
                                cpm_email: "",
                                run_status__in: null,
                            }}
                            onSubmit={values => this.handleSubmit(values)}
                        >
                            {props => {
                                const { values, setFieldValue, errors, touched } = props;
                                return (
                                    <Form>
                                        <div className="form-group">
                                            <label>Start date</label>
                                            <Field
                                                component={DatePicker}
                                                dateFormat="dd/MM/yyyy"
                                                onChange={value => setFieldValue("start_date", value, false)}
                                                name="start_date"
                                                autoComplete="off"
                                                selected={values.start_date}
                                                className={"form-control" + (errors.start_date && touched.start_date ? " is-invalid" : "")}
                                            />
                                            {errors.start_date && touched.start_date && (
                                                <div className="invalid-feedback d-block">{errors.start_date}</div>
                                            )}
                                        </div>
                                        <div className="form-group">
                                            <label>End date</label>
                                            <Field
                                                component={DatePicker}
                                                dateFormat="dd/MM/yyyy"
                                                onChange={value => setFieldValue("end_date", value, false)}
                                                name="end_date"
                                                autoComplete="off"
                                                selected={values.end_date}
                                                className={"form-control" + (errors.end_date && touched.end_date ? " is-invalid" : "")}
                                            />
                                            {errors.end_date && touched.end_date && (
                                                <div className="invalid-feedback d-block">{errors.end_date}</div>
                                            )}
                                        </div>
                                        <div className="form-group">
                                            <label>Customer Team</label>
                                            <CustomerTeamSelect
                                                value={values.customer_teams_id__in}
                                                onChange={val => setFieldValue("customer_teams_id__in", val, false)}
                                                isMulti
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Run Status</label>
                                            <AsyncSelect
                                                value={values.run_status__in}
                                                isClearable
                                                isMulti
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={oetService.getRunStatuses}
                                                onChange={val => setFieldValue("run_status__in", val, false)}
                                                placeholder="Select run status..."
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>OET ID</label>
                                            <Field name="oet_id" className="form-control" />
                                        </div>
                                        <div className="form-group">
                                            <label>OET Name</label>
                                            <Field name="oet_name" className="form-control" />
                                        </div>
                                        <div className="form-group">
                                            <label>CPO List</label>
                                            <Field name="cpo_numbers" className="form-control" />
                                        </div>
                                        <div className="form-group">
                                            <label>Circle</label>
                                            <Field name="circle" className="form-control" />
                                        </div>
                                        <div className="form-group">
                                            <label>CPM Email</label>
                                            <Field name="cpm_email" type="email" className="form-control" />
                                        </div>
                                        
                                        
                                        <Link to="/wiproimporter/" className="btn btn-primary">
                                            Import File
                                        </Link>
                                        <button type="submit" className="btn btn-success float-right">
                                            Generate and send to my e-mail
                                        </button>
                                        {this.state.isLoadig && (
                                            <div className="float-right">
                                                <ClipLoader />
                                            </div>
                                        )}
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                </div>
            </div>
        );
    }

    handleSubmit = values => {
        const request = {...values};
        request.start_date = moment(values.start_date).format("DD/MM/YYYY").replace("Invalid date", "");
        request.end_date = moment(values.end_date).format("DD/MM/YYYY").replace("Invalid date", "");
        request.customer_teams_id__in = values.customer_teams_id__in
            ? values.customer_teams_id__in.map(ct => ct.value)
            : [];
        request.run_status__in = values.run_status__in ? values.run_status__in.map(s => s.value) : [];
        const errorMessage = () =>
            swal({
                title: "Warning ...",
                text: "An error has occurred while trying to download the report",
                icon: "warning",
                button: true
            });
        this.setState({isLoadig: true});
        oetService.oetDashboardReport(request)
            .then(response => {
                this.setState({isLoadig: false})
                let { detail, progress_report } = response.data;
                swal({
                    title: !progress_report?"Success":"Error",
                    text: detail,
                    icon: !progress_report?"success":"error",
                    button: true
                });
            })
            .catch(error => {
                this.setState({isLoadig: false});
                if (error.response && error.response.status === 400 && error.response.data && error.response.data.detail) {
                    swal({
                        title: "Warning",
                        text: error.response.data.detail,
                        icon: "warning",
                        button: true
                    });
                } else {
                    errorMessage();
                }
            });
    };
}

export default OETDashboardReport;
